import { Component, OnInit } from '@angular/core';

import { NewsService } from '../../services/newsService'
import { ActivatedRoute } from '@angular/router'
declare var window: any;
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-detail-item-promotion-news',
  templateUrl: './detail-item-promotion-news.component.html',
  styleUrls: ['./detail-item-promotion-news.component.css']
})
export class DetailItemPromotionNewsComponent implements OnInit {

  ItemNews;
  itemNewAbout;
  constructor(private activatedRoute: ActivatedRoute, private nsv: NewsService,public _Title:Title) {
    
  }
  ngOnInit() {
    let id;
    let type;
    let Temp = this.nsv.getNewsPomotions();
    this.activatedRoute.params.subscribe(params => {
      id = params['id'];
      let TempItem = this.nsv.getNewsPomotions();
      TempItem.subscribe((snap)=>{
        for(var i=0;i<snap.length;i++){
          if(snap[i].id == id){
            this.ItemNews = snap[i];
          }
        }
      })
      /*this.ItemNews = this.nsv.getNewsPromotionId(id)
      if (this.ItemNews != null) {
        sessionStorage.setItem("is_reloaded_detail", JSON.stringify(this.ItemNews))
      }else{
        this.ItemNews = JSON.parse(sessionStorage.getItem("is_reloaded_detail"))
        
      }
      this._Title.setTitle(this.ItemNews.Head);*/
      
    })
    Temp.subscribe((snap) => {
      this.itemNewAbout = snap
      if (this.itemNewAbout != null) {
        sessionStorage.setItem("is_reloaded_about", JSON.stringify(this.ItemNews))
      }else{
        this.itemNewAbout = JSON.parse(sessionStorage.getItem("is_reloaded_about"))
      }
    })
    /*this.activatedRoute.params.subscribe(params => {
      type = params['types'];
    })

    if (type == '1') {
      let tempItem: any[] = [];
      let newsTemp = this.nsv.getNewsShow()
      newsTemp.subscribe((snap) => {
        //console.log(snap)
        for (var i = 0; i < snap.length; i++) {
          if (snap[i].type == '1') {
            tempItem.push(snap[i])
          }
        }
        this.ItemNews = tempItem[id]
        if (this.ItemNews != null) {
          sessionStorage.setItem("is_reloaded_detail", JSON.stringify(this.ItemNews))
        }else{
          this.ItemNews = JSON.parse(sessionStorage.getItem("is_reloaded_detail"))
        }
      })
    } else if (type == '2') {
      let tempItem: any[] = [];
      let PromotionTemp = this.nsv.getNewsShow()
      PromotionTemp.subscribe((snap) => {
        //console.log(snap)
        for (var i = 0; i < snap.length; i++) {
          if (snap[i].type == '2') {
            tempItem.push(snap[i])
          }
        }
        this.ItemNews = tempItem[id]
        if (this.ItemNews != null) {
          sessionStorage.setItem("is_reloaded_detail", JSON.stringify(this.ItemNews))
        }else{
          this.ItemNews = JSON.parse(sessionStorage.getItem("is_reloaded_detail"))
        }
      })
    }
    else if (type == 'all') {
      this.ItemNews = this.nsv.getNewsShowId(id);
      if (this.ItemNews != null) {
        sessionStorage.setItem("is_reloaded_detail", JSON.stringify(this.ItemNews))
      }else{
        this.ItemNews = JSON.parse(sessionStorage.getItem("is_reloaded_detail"))
      }
    }*/
    

   /* let itemNewAboutTemp = this.nsv.getNewsShow()
    itemNewAboutTemp.subscribe((snap) => {
      this.itemNewAbout = snap
      if (this.itemNewAbout != null) {
        sessionStorage.setItem("is_reloaded_about", JSON.stringify(this.ItemNews))
      }else{
        this.itemNewAbout = JSON.parse(sessionStorage.getItem("is_reloaded_about"))
      }
    })

  }
  getData() {
    let id;
    this.activatedRoute.params.subscribe(params => {
      id = params['id'];
    })
    this.ItemNews = this.nsv.getNewsShowId(id);
  }*/
}
}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/detail-item-promotion-news/detail-item-promotion-news.component.ts